import { Button, cn } from '@shared/components/shadcn';
import { Spinner } from '@shared/icons';
import { useTranslations } from 'next-intl';
import { useMultistepForm } from '../../../../form-controls/MultistepForm/hooks/useMultistepForm';
import type { ContinueButtonProps } from './types';

function ContinueButton({ onClick, disabled, children, variant = 'primary', className, loading, ...props }: ContinueButtonProps) {
  const { isLoading, isLastStep } = useMultistepForm();
  const t = useTranslations('form');
  const buttonType = isLastStep ? 'submit' : 'button';
  const finalButtonText = children || (isLastStep ? t('buttons.submit') : t('buttons.continue'));
  const isButtonLoading = isLoading || loading;
  const isButtonDisabled = Boolean(disabled) || isButtonLoading;
  const buttonContent = isButtonLoading ? <Spinner size="small" className="animate-spin w-5" aria-label={t('aria.loading')} /> : finalButtonText;

  return (
    <Button
      type={buttonType}
      variant={variant}
      onClick={onClick}
      disabled={isButtonDisabled}
      aria-busy={isButtonLoading || undefined}
      className={cn('w-full h-10', className)}
      data-testid="continue-button"
      {...props}
    >
      {buttonContent}
    </Button>
  );
}

export { ContinueButton };
